export const metaObj = {
    KENYA: {
        avaitorMeta: {
            title: "Online Aviator Game in Kenya | Betika",
            description: "Play and win Aviator Game in Kenya. With instant deposits and withdrawals plus cashback bonus. Sign up today."
        },
        virtualsMeta: {
            title: "Best Virtual Games in Kenya | Large Variety of Games | Betika",
            description: "We have the best Virtual Games in Kenya. Get instant deposits, withdrawals, and exclusive cashback bonuses. Sign up or log in now."
        },
        casinoMeta: {
            title: "Best Online Casino Games in Kenya | Betika",
            description: "We have the best Online Casino in Kenya. Get instant deposits, withdrawals, and exclusive cashback bonuses. Sign up or log in now."
        },
        betikaFastaMeta: {
            title: "Enjoy The Newest Cashout Games in Kenya | Betika Fasta",
            description: "We have the newest cashout game in Kenya. Get instant deposits, withdrawals, and exclusive cashback bonuses. Sign up or log in now."
        },
        promotionsMeta: {
            title: "Online Betting Promotions and Bonuses in Kenya | Betika",
            description: "Find the latests promotions and bonuses in Kenya. Get instant deposits, withdrawals, and exclusive cashback bonuses. Sign up or log in now."
        },
        crashGamesMeta: {
            title: "Best Crash Games In Kenya | Betika",
            description: "The most popular Crash games in Kenya. With instant deposits and withdrawals plus cashback bonus. Sign up today."
        },
    },
    GHANA: {
        avaitorMeta: {
            title: "Online Aviator Game in Ghana | Betika",
            description: "Play and win Aviator Game in Ghana. With instant deposits and withdrawals plus cashback bonus. Sign up today."
        },
        virtualsMeta: {
            title: "Best Virtual Games in Ghana | Large Variety of Games | Betika",
            description: "We have the best Virtual Games in Ghana. Get instant deposits, withdrawals, and exclusive cashback bonuses. Sign up or log in now."
        },
        casinoMeta: {
            title: "Best Online Casino Games in Ghana | Betika",
            description: "We have the best Online Casino in Ghana. Get instant deposits, withdrawals, and exclusive cashback bonuses. Sign up or log in now."
        },
        betikaFastaMeta: {
            title: "Enjoy The Newest Cashout Games in Ghana | Betika Fasta",
            description: "We have the newest cashout game in Ghana. Get instant deposits, withdrawals, and exclusive cashback bonuses. Sign up or log in now."
        },
        promotionsMeta: {
            title: "Online Betting Promotions and Bonuses in Ghana | Betika",
            description: "Find the latests promotions and bonuses in Ghana. Get instant deposits, withdrawals, and exclusive cashback bonuses. Sign up or log in now."
        },
        crashGamesMeta: {
            title: "Best Crash Games In Ghana | Betika",
            description: "The most popular Crash games in Ghana. With instant deposits and withdrawals plus cashback bonus. Sign up today."
        },
    },
    UGANDA: {
        avaitorMeta: {
            title: "Online Aviator Game in Uganda | Betika",
            description: "Play and win Aviator Game in Uganda. With instant deposits and withdrawals plus cashback bonus. Sign up today."
        },
        virtualsMeta: {
            title: "Best Virtual Games in Uganda | Large Variety of Games | Betika",
            description: "We have the best Virtual Games in Uganda. Get instant deposits, withdrawals, and exclusive cashback bonuses. Sign up or log in now."
        },
        casinoMeta: {
            title: "Best Online Casino Games in Uganda | Betika",
            description: "We have the best Online Casino in Uganda. Get instant deposits, withdrawals, and exclusive cashback bonuses. Sign up or log in now."
        },
        betikaFastaMeta: {
            title: "Enjoy The Newest Cashout Games in Uganda | Betika Fasta",
            description: "We have the newest cashout game in Uganda. Get instant deposits, withdrawals, and exclusive cashback bonuses. Sign up or log in now."
        },
        promotionsMeta: {
            title: "Online Betting Promotions and Bonuses in Uganda | Betika",
            description: "Find the latests promotions and bonuses in Uganda. Get instant deposits, withdrawals, and exclusive cashback bonuses. Sign up or log in now."
        },
        crashGamesMeta: {
            title: "Best Crash Games In Uganda | Betika",
            description: "The most popular Crash games in Uganda. With instant deposits and withdrawals plus cashback bonus. Sign up today."
        },
    },
    DRC: {
        avaitorMeta: {
            title: "Aviator jeux – Jouer Aviator en ligne | Betika",
            description: "Jouez et gagnez au jeu Aviator en RDC. Avec des dépôts et des retraits instantanés et un bonus cashback. Inscrivez-vous dès aujourd'hui!"
        },
        virtualsMeta: {
            title: "Jeux virtuels – Jeux en ligne | Betika",
            description: "Nous avons les meilleurs jeux virtuels en RDC. Obtenez des dépôts et des retraits instantanés, ainsi que des bonus cashback exclusifs. Inscrivez-vous ou connectez-vous maintenant!"
        },
        casinoMeta: {
            title: "Casino en ligne – Online casino | Betika",
            description: "Nous avons le meilleur Casino en ligne en RDC. Obtenez des dépôts et des retraits instantanés, ainsi que des bonus cashback exclusifs. S'inscrire ou se connecter maintenant!"
        },
        betikaFastaMeta: {
            title: "Betika fasta | Betika",
            description: "Nous avons le jeu de cashout le plus récent de RDC. Obtenez des dépôts et des retraits instantanés, ainsi que des bonus de cashback exclusifs. Inscrivez-vous ou connectez-vous maintenant!"
        },
        promotionsMeta: {
            title: "Betika promo – Trouvez des casino bonus et promo code ici | Betika",
            description: "Trouvez les dernières promotions et les derniers casino bonus en RDC. Obtenez des dépôts et des retraits instantanés, ainsi que des bonus de cashback exclusifs. S'inscrire ou se connecter maintenant !"
        },
        crashGamesMeta: {
            title: "Best Crash Games In DRC | Betika",
            description: "Les jeux Crash les plus populaires en RDC. Avec dépôts et retraits instantanés ainsi que bonus de cashback. Inscrivez-vous aujourd'hui."
        },
    },
};
